export enum SusyFormFieldLabelPosition {
    TOP = 'top',
    LEFT = 'left',
}

export enum SusyFormFieldBackgroundLightnessType {
    DARK = 'dark',
    LIGHT = 'light',
}
